import { useResendCodeConfigStore } from "@repo/core/stores/resendCodeConfig";
import {
  parseSmsResendSeconds,
  PhoneVerificationResource
} from "@repo/core/services/resources/phone-verification";
import { wayupApiInstance } from "@repo/core/services/instances/wayup-api";
import { useCallback } from "react";

const phoneVerificationResource = new PhoneVerificationResource(
  wayupApiInstance
);

const DEFAULT_VALUES = {
  empresaParam: "01",
  codigoPacoteParam: "0010",
  defaultSeconds: 59
};

export const useResendCodeConfig = () => {
  const expiresInSeconds = useResendCodeConfigStore((s) => s.expiresInSeconds);
  const setExpiresInSeconds = useResendCodeConfigStore(
    (s) => s.setExpiresInSeconds
  );
  const resetStore = useResendCodeConfigStore((s) => s.reset);

  const fetchResendConfig = useCallback(async () => {
    try {
      const empresaParam = DEFAULT_VALUES.empresaParam;
      //should be removed when backend starts to return the correct expiration time for each product
      const codigoPacoteParam = DEFAULT_VALUES.codigoPacoteParam;

      const { data } = await phoneVerificationResource.fetchSmsResendConfig(
        empresaParam,
        codigoPacoteParam
      );

      const seconds = parseSmsResendSeconds(
        data,
        DEFAULT_VALUES.defaultSeconds
      );
      setExpiresInSeconds(seconds);
    } catch (error) {
      console.error("Failed to fetch SMS resend configuration", error);
      setExpiresInSeconds(DEFAULT_VALUES.defaultSeconds);
    }
  }, [setExpiresInSeconds]);

  const setExpiresInSecondsPublic = (value: number): void => {
    setExpiresInSeconds(value);
  };

  const reset = (): void => {
    resetStore();
  };

  return {
    expiresInSeconds,
    fetchResendConfig,
    setExpiresInSeconds: setExpiresInSecondsPublic,
    reset
  };
};
